import { AnimatePresence, motion } from "motion/react";
import clsx from "clsx";
import { ShieldCheck, SunIcon } from "@/shared/icons";
import { Wheather, wheather } from "@/domains/hud/constants/global";

type Props = {
  isGreenZone: boolean;
  wheatherState: Wheather;
  wheatherDegree: number;
  className?: string;
};

export default function HudMap({ isGreenZone, wheatherDegree, wheatherState, className }: Props) {
  return (
    <div className={clsx("relative w-[--map-w] h-[--map-h] isolate", className)}>
      <div className="absolute top-3.5 w-full px-3.5 z-1 flex items-center gap-1.5 text-14 font-medium text-white">
        <SunIcon size={16} color="text-white" />
        <div className="text-11 font-medium uppercase text-white">{wheather[wheatherState]}</div>
        <div className="whitespace-nowrap ml-auto text-13 font-bold text-white">
          {wheatherDegree}&deg;C
        </div>
      </div>
      <AnimatePresence>
        {isGreenZone ? (
          <motion.div
            initial={{
              opacity: 0,
            }}
            animate={{
              opacity: 1,
            }}
            className={clsx(
              "absolute top-0 bottom-0 right-0 bg-dark-900/50 left-0 rounded-[0.625rem] transition-opacity",
            )}
            exit={{ opacity: 0 }}
          >
            <div className="relative flex flex-col items-center justify-end h-[90%] overflow-clip ">
              <div
                className="absolute z-1 w-full h-full bottom-0"
                style={{
                  background:
                    "radial-gradient(50% 138.39% at 50% 100%, rgba(95, 255, 105, 0.20) 0%, rgba(18, 18, 18, 0.00) 100%)",
                }}
              />
              <motion.div
                initial={{ opacity: 0, translateY: "-200%" }}
                animate={{ opacity: 1, translateY: "none" }}
                exit={{ opacity: 0, translateY: "100%" }}
                className="z-2 flex flex-col items-center gap-2 py-3 text-11 font-bold text-white uppercase"
              >
                <ShieldCheck size={24} className="text-[#5FFF69]" />
                Зеленая зона
              </motion.div>
            </div>
            <motion.div
              initial={{
                width: 0,
              }}
              animate={{
                width: "100%",
              }}
              exit={{
                width: 0,
              }}
              transition={{
                delay: 0.2,
              }}
              className="h-1"
              style={{
                background:
                  "linear-gradient(90deg, rgba(132, 255, 151, 0.00) 0%, #84FF97 50%, rgba(132, 255, 151, 0.00) 100%)",
              }}
            />
          </motion.div>
        ) : null}
      </AnimatePresence>
    </div>
  );
}
